<template>
    <tr @click="handleClick" class="vue-location-dropdown-item">
        <td>
            <button @click.stop="handleClick">
                {{ item.place }}
            </button>
        </td>
        <td>
            <span class="font-weight-bold" v-if="item.distance">
                {{ item.distance | distance }}
            </span>
        </td>
    </tr>
</template>

<script>
export default {
    name: "DropdownItem",

    props: {
        item: {
            type: Object,
            required: true,
        }
    },

    filters: {
        distance(value) {
            return `${value.toFixed(0)} km`
        }
    },

    methods: {
        handleClick() {
            this.$emit('clicked', this.item);
        }
    }
}
</script>